import React from "react";
import styles from "../components/laymanComp_css/LaymanPage34.module.css";
import { Link } from "@mui/material";

export default function LaymanPage34() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF VIRGO</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.om_block_main}>
                <div
                  className={`${styles.om_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/virgo/vigro_1img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/virgo/vigro_1img.webp`}/>
                  </div>
                  {/* className={styles.yellow_txt} */}
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>
                          Virgo's Wisdom: The Virgin Journey of Introspection
                        </h2>
                      </div>
                      <p>
                        <span><i>"The unexamined life is not worth living" </i></span>{" "}
                        These timeless words spoken by Socrates echo the essence
                        of Virgo, a Cosmic Archetype deeply embedded in the
                        fabric of <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and{" "}
                        Archetypal Astrology. Virgo, representing a Mutable Earth Influence, calls
                        individuals to embark on a profound journey of
                        introspection and scholarly examination of existence.
                      </p>
                      <p>
                        The Virgo Archetype, akin to the last years of
                        introspection by notable figures such as{" "}
                        Carl Jung, Aleister Crowley, Marie-Louise von Franz,
                        Joan of Arc, Socrates, and Werner Heisenberg, captures
                        the essence of reflection, both historical and
                        immanent. The symbolism of the <span><i>"virgin"</i></span> in Virgo
                        encapsulates the innocence and freshness of each moment
                        in life—from birth to the awakening of puberty, the
                        first sexual experience, and unto the moment of death.
                      </p>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Symbolic Essence of OM:</h2>
                      </div> */}
                      <p>
                        Virgo beckons us to delve deeply into the hidden
                        meanings of our experiences, guided by the Mercurial
                        messenger{" "} (Virgo being ruled by Mercury).
                        In the Thoth Tarot, this profound introspection is
                        represented by <span><i>"The Hermit"</i></span>. The Old Sage,
                        mesmerized by the Orphic Egg symbolizing the continuous
                        process of creation, stands with hounds of hell—sacred
                        to Hecate of the Underworld—at his feet. Carrying the
                        Lantern of knowledge, the Hermit signifies the matured
                        flowering of the life process, a secret understanding of
                        the eternal Virgin experience within the wonder of
                        existence.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/virgo/vigro_2img.webp"
                    /> */}
                    <img className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/virgo/vigro_2img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Vibration and Chanting:</h2>
                      </div> */}
                      <p>
                        To work under the influence of Virgo is to weave
                        together wisdom, introspection, and a scholarly approach
                        to existence. It is a continuous study of new things
                        while deepening the habit of peering into one's current
                        and past life processes. Virgo invites individuals to
                        embrace a springtime thinking in the vast history of our
                        race, committing to the virgining <i>"Cosmic Process"</i> of
                        their Transpersonal Journey.
                      </p>

                      <p>
                        As we navigate the intricate tapestry of life under the
                        guidance of Virgo, we find ourselves immersed in the
                        timeless pursuit of self-discovery and wisdom, each
                        moment an opportunity to uncover the hidden truths
                        within the vast expanse of our existence.
                      </p>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <div className={styles.bullet_cont}>
                        <p>
                          <b>Cosmic Archetype:</b> Virgo is a significant Cosmic
                          Archetype within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being </Link>
                          method and Archetypal Astrology, embodying the essence
                          of Mutable Earth Influence.
                        </p>
                        <p>
                        <b>Introspection and Reflection:</b> Virgo symbolizes a deep
                          call to introspection and reflection, akin to the
                          profound introspective years of influential figures
                          like Carl Jung, Aleister Crowley,{" "} Marie-Louise von Franz, Joan of Arc, Socrates, and Werner Heisenberg.
                        </p>
                        <p>
                        <b>Virgin Symbolism:</b> The <span><i>"virgin"</i></span> aspect of
                          Virgo signifies innocence and freshness at various
                          stages of life—from birth to the awakening of puberty,
                          the first sexual experience, and ultimately unto
                          death.
                        </p>
                        <p>
                        <b>Hidden Meanings:</b> Virgo calls individuals to delve
                          deeply into hidden meanings within their experiences,
                          guided by the Mercurial messenger as Virgo is ruled by
                          Mercury.
                        </p>
                        <p>
                        <b>Thoth Tarot - The Hermit:</b> The Virgo influence is
                          represented by <span><i>"The Hermit"</i></span> in the Thoth
                          Tarot, depicting an Old Sage mesmerized by the{" "} Orphic Egg,{" "}
                          symbolizing the continuous process of creation.
                        </p>
                        <p>
                        <b>Hounds of Hell Symbolism:</b> The hounds of hell at{" "} the Hermit's feet, 
                        sacred to Hecate of the Underworld, represent the
                          tamed aspects of the unconscious during the process of
                          introspection.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/virgo/vigro_3img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/virgo/vigro_3img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div> */}
                      <p>
                        <b>Lantern of Knowledge:</b> The{" "}
                          Hermit carries the Lantern, symbolizing the knowledge of the Hidden Inner Light
                        gained through a lifetime of introspective experiences.
                      </p>

                      <p>
                        <b>Eternal Virgin Experience:</b> The Hermit's secret
                        knowledge lies in understanding the eternal Virgin
                        experience within the wonder of existence, representing
                        the matured flowering of the life process.
                      </p>
                      <p>
                        <b>Scholarly Approach:</b> Working under the influence
                        of{" "}
                          Virgo encourages a scholarly approach{" "}
                        to existence, combining wisdom, introspection, and
                        continuous study of new things.
                      </p>
                      <p>
                        <b>Springtime Thinking:</b> Virgo invites individuals to
                        adopt a springtime thinking in the vast history of the
                        human race, committing to the ongoing{" "}
                        <span><i>"Cosmic Process"</i></span> of their Transpersonal
                        Journey.
                      </p>
                    </div>
                  </div>
                </div>
                {/* <div
                  className={`${styles.om_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    <img
                      className={styles.orphic_egg_img1}
                      src=""
                    />
                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Vigor of Statehood:</b> Aries, much like the Spartans, draws on the vigor of statehood,
                        recognizing the importance of maintaining dominion and authority.

                      </p>

                      <p>
                        <b>Conditioning through Discipline:</b> The violent warrior tendencies of Aries can be
                        conditioned through discipline and an ascetic life, much like the Spartan way of life.
                      </p>
                      <p>
                        <b>Hidden Madness and Bloodthirsty Energy:</b> Aries hides a dormant madness and <span className={styles.yellow_txt}>bloodthirsty energy,</span> ready to be unleashed when facing formidable enemies, whether external or internal.
                      </p>

                      <p>
                        <b>Set Your House in Order:</b> Working under the influence of Aries is akin to setting one's house
                        in order, ruling one's domain with authority and defending it fiercely.
                      </p>

                      <p>
                        <b>Challenge and Refinement:</b> Aries draws on challenge and refinement, encouraging
                        individuals to seek conquest, gain valuable possessions, and rid themselves of useless burdens.
                      </p>

                      <p>
                      <b>Emperor of Thoth :</b>  <span className={styles.yellow_txt}>The Emperor of Thoth</span> archetype invokes the impulse to create or destroy, ruling with the wisdom of kingship, embodying the essence of Aries.
                      </p>
                    
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            {/* =========================================greensec---------------------------------------------               */}

            <div className={styles.green_sec_cmn_main_wrp}>
              <div className={styles.common_width}>
                <Link href="/rota-the-wheel">
                  <div className={styles.green_sec_cmn_sub_wrp}>
                    <h1>
                      The Astrological Tarot association for Virgo is <br /> The
                      Hermit. See our alchemical ROTA here
                    </h1>
                  </div>
                </Link>
              </div>
            </div>
            {/* ---------------------------------------------------greensec_end=================================== */}

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_virgo/layman_page34_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_virgo/layman_page34_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_virgo/layman_page34_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_virgo/layman_page34_block4_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
